import { render, staticRenderFns } from "./LeadXpress.vue?vue&type=template&id=00976e38&"
import script from "./LeadXpress.vue?vue&type=script&lang=js&"
export * from "./LeadXpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports